<template>
  <div class="p-0 border m-auto" ref="container">
    <canvas :width="width" :height="height" ref="canvas"></canvas>
  </div>
</template>
<script>
import Konva from 'konva'

export default {
  name: 'DrawCanvas',
  props: {
    'memoBackGroundImage': String,
    'drawMode': String,
    'penColor': String,
    'lineWidth': String,
    'allClearFlag': Boolean
  },
  data: () => ({
    width: 1200,
    height: 450,
    stage: null,
    canvas: null,
    context: null,
    drawingLayer: null,
    drawingScope: null,
    lastPointerPosition: {},
    localPos: {
      x: 0,
      y: 0
    },
    pos: null,
    imageObj: null,
    backgroundLayer: null,
    backgroundImageScope: null
  }),
  mounted: function () {
    var container = this.$refs.container
    this.stage = new Konva.Stage({
      container,
      width: this.width,
      height: this.height
    })
    this.drawingLayer = new Konva.Layer()
    this.stage.add(this.drawingLayer)

    this.canvas = this.$refs.canvas
    this.context = this.canvas.getContext('2d')
    this.drawingScope = new Konva.Image({
      image: this.canvas,
      x: 0,
      y: 0,
      stroke: '',
      fill: '#FFF'
    })
    this.drawingLayer.add(this.drawingScope)
    this.stage.draw()

    // イベント追加
    this.drawingScope.on('mousedown', this.mousedown)
    this.stage.addEventListener('mouseup', this.mouseup)
    this.stage.addEventListener('mousemove', this.mousemove)
    this.drawingScope.on('touchstart', this.mousedown)
    this.stage.addEventListener('touchend', this.mouseup)
    this.stage.addEventListener('touchmove', this.mousemove)
  },
  watch: {
    memoBackGroundImage: function (newData, oldData) {
      this.imageObj = new Image()
      this.imageObj.src = newData
      const imageObj = this.imageObj
      imageObj.onload = (e) => {
        this.imageOnload()
        this.stage.draw()
      }
    },
    drawMode: function () {
      // モード変更時
      this.context.globalCompositeOperation = this.drawMode
      this.context.lineWidth = Number(this.lineWidth)
    },
    penColor: function () {
      // ペンカラー変更時
      this.context.strokeStyle = this.penColor
    },
    lineWidth: function () {
      // 太さ変更時
      this.context.lineWidth = Number(this.lineWidth)
    }
  },
  methods: {
    mousedown: function () {
      this.isPaint = true

      // マウスダウン時の座標を取得しておく
      this.lastPointerPosition = this.stage.getPointerPosition()
    },
    mouseup: function () {
      this.isPaint = false
    },
    mousemove: function () {
      if (!this.isPaint) {
        return
      }
      this.context.lineWidth = Number(this.lineWidth)
      this.context.lineJoin = 'round'
      // 描画処理
      if (this.allClearFlag && this.context.globalCompositeOperation === 'destination-out') {
        this.context.strokeStyle = '#ffffff'
        this.context.globalCompositeOperation = 'source-over'
        this.drawing(this.stage.getPointerPosition())
        this.context.strokeStyle = this.penColor
        this.context.globalCompositeOperation = 'destination-out'
      } else {
        this.drawing(this.stage.getPointerPosition())
      }
    },
    drawing (pointerPosition) {
      this.context.beginPath()
      this.localPos.x = this.lastPointerPosition.x - this.drawingScope.x()
      this.localPos.y = this.lastPointerPosition.y - this.drawingScope.y()

      // 描画開始座標を指定する
      this.context.moveTo(this.localPos.x, this.localPos.y)

      this.pos = pointerPosition
      this.localPos.x = this.pos.x - this.drawingScope.x()
      this.localPos.y = this.pos.y - this.drawingScope.y()

      // 描画開始座標から、lineToに指定された座標まで描画する
      this.context.lineTo(this.localPos.x, this.localPos.y)
      this.context.closePath()
      this.context.stroke()
      this.drawingLayer.draw()

      this.lastPointerPosition = this.pos
    },
    onExportDrawnImage: function () {
      this.$emit('saveMeetingMemo', this.stage.toDataURL())
    },
    calculateWidth () {
      const computedStyle = window.getComputedStyle(document.getElementById('meeting-memo'))
      this.width = document.getElementById('meeting-memo').clientWidth - (parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight))
      this.stage.width(this.width - 2) // ボーダー2px分をマイナス
    },
    clearCanvas: function () {
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.drawingLayer.draw()
    },
    allClearCanvas: function () {
      if (this.context.globalCompositeOperation === 'destination-out') {
        this.context.globalCompositeOperation = 'source-over'
        this.context.fillStyle = '#ffffff'
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height)
        this.drawingLayer.draw()
        this.context.globalCompositeOperation = 'destination-out'
      } else {
        this.context.fillStyle = '#ffffff'
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height)
        this.drawingLayer.draw()
      }
    },
    imageOnload: function () {
      this.drawingScope.fill(null)
      this.backgroundLayer = new Konva.Layer()
      this.backgroundImageScope = new Konva.Image({
        image: this.imageObj,
        x: 0,
        y: 0,
        width: this.canvas.width,
        height: this.canvas.height
      })
      this.backgroundLayer.add(this.backgroundImageScope)
      this.stage.add(this.backgroundLayer)
      this.backgroundLayer.moveToBottom()
      this.context.globalCompositeOperation = this.drawMode
      this.context.strokeStyle = this.penColor
    }
  }
}
</script>
